import {
  BookOpen, Compass, Heart, Tent, Home, Fish, Pickaxe, Hammer,
  Coins, Swords, HandHeart, Sparkles, Map, ScrollText, Users, Flame,
} from "lucide-react";

// Icon name (stored in Admin) → lucide component. Falls back to BookOpen.
export const GUIDE_ICONS = {
  BookOpen, Compass, Heart, Tent, Home, Fish, Pickaxe, Hammer,
  Coins, Swords, HandHeart, Sparkles, Map, ScrollText, Users, Flame,
};

export const GUIDE_ICON_NAMES = Object.keys(GUIDE_ICONS);

export const guideIcon = (name) => GUIDE_ICONS[name] || BookOpen;
